'use strict';

var Decorator = require('utils/decoration');
var I18N = require('utils/i18n');

var Validator = {};

// error constants
Validator.ErrorCodes = {
    TooShort: 1,
    NoNumber: 2,
    NoCases: 3,
    NoSpecChars: 4,
    RegexNotMatched: 5,
    NotChecked: 6,
    NotANumber: 7,
    TooSmall: 9,
    TooBig: 10,
};

/**
 * Validates the given string. If it is valid, it returns an emtpy array,
 * otherwise an array with errorcodes (see the enums Validator.ErrorCodes for the codes).
 * @param  {string} password
 * @return {array}  The error-codes found, if any.
 */
Validator.validatePassword = function (password) {
    var errors = [];
    var length = 8;
    var cases = true;
    var number = true;
    var specialChars = RegExp('[^0-9a-zA-Z]');

    if (password.length < length) {
        errors.push(Validator.ErrorCodes.TooShort);
    }
    if (cases && (!/[a-z]/.test(password) || !/[A-Z]/.test(password))) {
        errors.push(Validator.ErrorCodes.NoCases);
    }
    if (number && !/[0-9]/.test(password)) {
        errors.push(Validator.ErrorCodes.NoNumber);
    }

    if (-1 === password.search(specialChars)) {
        errors.push(Validator.ErrorCodes.NoSpecChars);
    }

    return errors;
};

/**
 * Checks if the given input has the minimum length and if so also checks if the given regular expression is fullfilled.
 * @param  {[String]} input              The String to be checked
 * @param  {[integer]} length            The minimum length the string must have
 * @param  {[regular expression]} regex  The regular Expression that has to be fullfilled
 * @return {[enum]}                      The first Error wich was found (so either "TooShort" or "RegexNotMatched")
 */
Validator.validateText = function (input, length, regex) {
    if (input.length < length) {
        return [Validator.ErrorCodes.TooShort];
    }
    if (regex && !regex.test(input)) {
        return [Validator.ErrorCodes.RegexNotMatched];
    }
    return [];
};

/**
 * Short-form of validateText(input,0,'\\S+@\\S+\\.\\S+', 'i'). For more details see validateText.
 * double backslash is required or else \. -> . and \S -> S
 */
Validator.validateEmail = function (input) {
    var email = RegExp('^\\S+@\\S+\\.\\S+$', 'i');
    return Validator.validateText(input, 0, email);
};

Validator.validateEmailOrPhone = function (input) {
    var validateEmailErrors = this.validateEmail(input);
    if (validateEmailErrors.length === 0) {
        // correct email -> return
        return [];
    }

    // invalid email - validate as phone number
    var phone = RegExp('^\\+?[ 0-9]+$', 'i');
    return Validator.validateText(input, 0, phone);
};

Validator.validateNumber = function (input, min, max) {
    input = ('' + input).trim();
    var number = parseInt(input);
    var numberRegExp = RegExp('^-?[0-9]+$', 'i');

    if (isNaN(number) || !numberRegExp.test(input)) {
        return [Validator.ErrorCodes.NotANumber];
    }
    if (number < min) {
        return [Validator.ErrorCodes.TooSmall];
    }
    if (number > max) {
        return [Validator.ErrorCodes.TooBig];
    }

    return [];
};

Validator.validate = function (form, fct, onError, errorTriggerOnce) {
    var oldErrors = form.errors;
    var errorTriggered = false;

    var triggerError = function (name, ctrl, message, contextData) {
        form.errors[name] = message;
        if (ctrl) {
            Decorator.flash(ctrl);
        }

        if (!onError) return;
        if (errorTriggered && errorTriggerOnce) return;

        errorTriggered = true;
        onError.apply(form, arguments);
    };

    form.errors = {};
    var validationObj = {
        custom: function (name, fct, ctrl, contextData) {
            var msg = fct();
            if (msg) triggerError(name, ctrl, msg, contextData);
        },

        maxLen: function (name, value, maxLen, message, ctrl, contextData) {
            if ((value || '').length > maxLen && message) {
                triggerError(name, ctrl, message, contextData);
            }
        },

        emptyOrNumber: function (name, value, message, ctrl, contextData) {
            if ((value || '') != '' && isNaN(parseInt(value))) {
                triggerError(name, ctrl, message, contextData);
            }
        },

        required: function (name, valueCtrl, message, ctrl, contextData) {
            var val = undefined;
            if (valueCtrl && valueCtrl.val) {
                val = valueCtrl.val();
            } else {
                val = valueCtrl;
            }

            if (!ctrl) ctrl = valueCtrl;

            if (!val) triggerError(name, ctrl, message, contextData);
        },
    };

    fct.apply(validationObj, [form]);
    if (JSON.stringify(form.errors) != JSON.stringify(oldErrors)) form.render();

    return _.keys(form.errors).length == 0;
};

module.exports = Validator;
